module.exports = __webpack_public_path__ + "static/media/ar21_wwallace.6977c96a.jpeg";